<div #printContent id="printContent">
  <button class="tourPageBtn mr-3" id="help-tour-btn" (click)="startTour()" title="Take a tour">
    <img src="/assets/images/tutorialOverlayBttn.svg" />
  </button>
  <div class="print-hide" *ngIf="showSchoolFilter">
    <wf-school-teacher-filter
      [error]="schoolFilterError"
      [districts]="districts"
      [schools]="schools"
      [teachers]="teachers"
      (filterChangeEvent)="filterSchoolTeacher()"
    ></wf-school-teacher-filter>
  </div>
  <div [ngClass]="{ 'disabled-report' : schoolFilterError }"></div>
  <div class="header-controls justify-content-between">
    <h3>
      <fa-icon [classes]="['print-hide']" [icon]="reportsIcon"></fa-icon>
      Reports
    </h3>
    <div class="button-group">
      <div *ngIf="showCoTeacherFilter" class="form-check">
        <input id="coteacher-checkbox" class="form-check-input" type="checkbox" [(ngModel)]="hideSharedStudents" (change)="toggleSharedStudents()">
        <label class="form-check-label" for="coteacher-checkbox">Hide Shared Students</label>
      </div>
      <refresh-button
        (click)="refreshUnitDetails()">
      </refresh-button>
      <div class="btn-group print-hide" ngbDropdown>
        <button id="export-button" class="btn export-report-button" (click)="exportUnitDetail(false)" [disabled]="exportingReport || !selectedStudent || !selectedUnit">
          <fa-icon [icon]="excelIcon" *ngIf="!exportingReport"></fa-icon>
          <fa-icon [icon]="loadingIcon" [spin]="true" *ngIf="exportingReport"></fa-icon>
          Export Results
        </button>
        <button class="btn export-report-button dropdown-toggle-split" ngbDropdownToggle [disabled]="exportingReport || !selectedStudent || !selectedUnit"></button>
        <div ngbDropdownMenu>
          <button ngbDropdownItem (click)="exportUnitDetail(false)">Export Results</button>
          <button ngbDropdownItem (click)="exportUnitDetail(true)">Export with Trial Data</button>
        </div>
      </div>
      <button id="print-button" class="btn print-summary-button print-hide" (click)="printSummary()" *ngIf="!currentUser!.isTeacherReviewUser()"><fa-icon [icon]="printIcon"></fa-icon> Print Results</button>
    </div>
  </div>
  <div class="report-section-header" style="justify-content: space-between;">
    <h5 class="results-report-header">
      <fa-icon [classes]="['print-hide']" [icon]="detailIcon"></fa-icon>
      Unit Detail
    </h5>
  </div>
  <div class="boxed-content">
    <div class="print-hide alert message alert-danger" id="export-error" *ngIf="reportError">
      <div class="icon">
        <fa-icon [icon]="errorIcon"></fa-icon>
      </div>
      <div>
        <div class="bold">Report Export Error</div>
        {{ reportError }}
      </div>
    </div>
    <div class="student-dropdown-row flex column-gap-10 print-hide" style="align-items: flex-end ;">
      <div id="student-dropdown-field" class="width-25">
        <label for="student-dropdown">Student</label>
        <select id="student-dropdown" class="form-select print-hide" [(ngModel)]="selectedStudent" (change)="getInterventionTaskDetails()">
          <option *ngFor="let student of currentStudents; trackBy: trackByStudentId" [ngValue]="student">{{ student.firstName }} {{ student.lastName }}</option>
        </select>
      </div>
      <div id="unit-dropdown-field" class="width-25">
        <label for="unit-dropdown">Unit</label>
        <select id="unit-dropdown" class="form-select print-hide" [(ngModel)]="selectedUnit" (change)="studentTaskFilterChanged()">
          <option *ngFor="let unit of units" [ngValue]="unit">{{ unit.summary }}</option>
        </select>
      </div>
      <div id="task-dropdown-field" class="width-25">
        <label for="task-dropdown">Category</label>
        <select id="task-dropdown" class="form-select print-hide" [(ngModel)]="selectedTaskCategory" (change)="studentTaskFilterChanged()">
          <option *ngFor="let category of taskCategories" [ngValue]="category">{{ category.name }}</option>
        </select>
      </div>
      <div *ngIf="!selectedStudent" class="school-teacher-filter-error-label" style="margin-bottom: 5px ;">Please select a Student</div>
      <div *ngIf="selectedStudent && !selectedUnit" class="school-teacher-filter-error-label" style="margin-bottom: 5px ;">Please select a Unit</div>
    </div>
    <div class="print-show">
      <div><span class="bold">Student:</span> {{selectedStudent?.firstName || ''}} {{selectedStudent?.lastName || ''}}</div>
      <div><span class="bold">Grade:</span> {{selectedStudent?.grade | displayGrade }}</div>
      <div><span class="bold">Unit:</span> {{selectedUnit?.summary || ''}}</div>
      <div><span class="bold">Category:</span> {{selectedTaskCategory.name || 'All'}}</div>
    </div>
    <table class="table table-borderless student-table print-hide">
      <thead class="student-table-header">
      <tr>
        <th>First Name</th>
        <th>Last Name</th>
        <th>Grade</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>{{selectedStudent?.firstName}}</td>
        <td>{{selectedStudent?.lastName}}</td>
        <td>{{selectedStudent?.grade | displayGrade }}</td>
      </tr>
      </tbody>
    </table>
    <table id="unit-detail-table" class="table unit-detail-table accordion">
      <thead id="main-table" class="student-table-header">
      <tr>
        @let sortColumn = studentTaskSort().column;
        @let sortReverse = studentTaskSort().reverse;
        <th (click)="sortChanged('taskName')">
          <div class="sortable-report-table-header" style="justify-content: left;">
            Task
            <div [ngClass]=" { 'arrow-up' : !sortReverse, 'arrow-down': sortReverse }" [style.visibility]="(sortColumn !== 'taskName') ? 'hidden' : 'visible'"></div>
          </div>
        </th>
        <th (click)="sortChanged('unitNumber')">
          <div class="sortable-report-table-header" style="justify-content: left;">
            Unit
            <div [ngClass]=" { 'arrow-up' : !sortReverse, 'arrow-down': sortReverse }" [style.visibility]="(sortColumn !== 'unitNumber') ? 'hidden' : 'visible'"></div>
          </div>
        </th>
        <th (click)="sortChanged('level')">
          <div class="sortable-report-table-header" style="justify-content: left;">
            Level
            <div [ngClass]=" { 'arrow-up' : !sortReverse, 'arrow-down': sortReverse }" [style.visibility]="(sortColumn !== 'level') ? 'hidden' : 'visible'"></div>
          </div>
        </th>
        <th (click)="sortChanged('wordListString')">
          <div class="sortable-report-table-header" style="justify-content: left;">
            Wordlist
            <div [ngClass]=" { 'arrow-up' : !sortReverse, 'arrow-down': sortReverse }" [style.visibility]="(sortColumn !== 'wordListString') ? 'hidden' : 'visible'"></div>
          </div>
        </th>
        <th (click)="sortChanged('duration')">
          <div class="sortable-report-table-header" style="justify-content: left;">
            Time (mm:ss)
            <div [ngClass]=" { 'arrow-up' : !sortReverse, 'arrow-down': sortReverse }" [style.visibility]="(sortColumn !== 'duration') ? 'hidden' : 'visible'"></div>
          </div>
        </th>
        <th (click)="sortChanged('dateCompleted')">
          <div class="sortable-report-table-header" style="justify-content: left;">
            Date
            <div [ngClass]=" { 'arrow-up' : !sortReverse, 'arrow-down': sortReverse }" [style.visibility]="(sortColumn !== 'dateCompleted') ? 'hidden' : 'visible'"></div>
          </div>
        </th>
        <th (click)="sortChanged('percentCorrect')">
          <div class="sortable-report-table-header" style="justify-content: left;">
            Percent Correct
            <div [ngClass]=" { 'arrow-up' : !sortReverse, 'arrow-down': sortReverse }" [style.visibility]="(sortColumn !== 'percentCorrect') ? 'hidden' : 'visible'"></div>
          </div>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr *ngIf="taskRetrievalError"><td colspan="7" style="text-align: center; color: red;">There was an error retrieving the student's task data.  If the problem persists, please contact support.</td></tr>
        @for (task of studentTasksDisplay(); track $index) {
          @if (task.taskTitle) {
            <tr class="intervention-task">
              <td>
                <div>{{ task.taskName }}</div>
                <div class="task-title"><fa-icon [icon]="titleIcon" class="print-hide"></fa-icon> {{ task.taskTitle }}</div>
              </td>
              <td>{{ task.unitNumber }}</td>
              <td>{{ task.level }}</td>
              <td>{{ task.wordListString }}</td>
              <td>&mdash;</td>
              <td>{{ task.dateCompletedString }}</td>
              <td *ngIf="task.numberOfTrials === 0">&mdash;</td>
              <td *ngIf="task.numberOfTrials !== 0">{{ (task.correctTrials/task.numberOfTrials*100) | number: '1.0-0' }}%</td>
            </tr>
          } @else {
            <tr class="intervention-task">
              <td>{{ task.taskName }}</td>
              <td>{{ task.unitNumber }}</td>
              <td>{{ task.level }}</td>
              <td>{{ task.wordListString }}</td>
              <td>{{ task.duration }}</td>
              <td>{{ task.dateCompletedString }}</td>
              <td *ngIf="task.numberOfTrials === 0">&mdash;</td>
              <td *ngIf="task.numberOfTrials !== 0">
                <span style="display: inline-block; width: 40%">{{ (task.correctTrials/task.numberOfTrials*100) | number: '1.0-0' }}%</span>
                <a [href]="'#trials-' + task.studentInterventionTaskId" role="button" data-bs-toggle="collapse" class="collapsed" (click)="toggleTaskTrials(task.studentInterventionTaskId)" >
                  <fa-icon class="print-hide" [icon]="(expandedTaskId === task.studentInterventionTaskId) ? collapseIcon : expandIcon"></fa-icon>
                </a>
              </td>
            </tr>
            <tr class="intervention-task-trials accordion-item">
              <td colspan="7" style="padding: 0 ; border-collapse: collapse ;">
                <div class="collapse accordion-collapse" [id]="'trials-' + task.studentInterventionTaskId" data-bs-parent="#unit-detail-table">
                  <table>
                    <thead>
                    <tr>
                      <th>Trial #</th>
                      @if (task.taskID.startsWith('FSU') || task.taskID.startsWith('FSM')) {
                        <th>Target Word</th>
                      }
                      <th>Trial Target</th>
                      <th>Student Response</th>
                      <th>Correct?</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let trial of task.trialData; index as trialIdx" [ngClass]="{ 'trial-incorrect': !trial.isCorrect }">
                      <td>{{ trialIdx + 1 }}</td>
                      @if (task.taskID.startsWith('FSU') || task.taskID.startsWith('FSM')) {
                        <td>{{ trial.foil || '&mdash;' }}</td>
                      }
                      <td>{{ trial.target }}</td>
                      <td>{{ trial.response }}</td>
                      <td *ngIf="trial.isCorrect" class="trial-correct"><fa-icon class="print-icon green-color" [icon]="correctIcon"></fa-icon></td>
                      <td *ngIf="!trial.isCorrect"><fa-icon class="print-icon red-color" [icon]="incorrectIcon"></fa-icon></td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
          }
        } @empty {
          <tr>
            <td colspan="7" class="center-text">
              @if (studentTaskFilters().unit?.number === 0) {
                Select a specific unit to view data, or use Export to download all units.
              } @else {
                No records for this Unit {{ studentTaskFilters().category.type !== TaskCategoryTypes.ALL ? '& Category' : '' }}
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
